import React from "react";
import { useT } from "@/lib/LanguageContext";
import CrmDialog from "../../ui/CrmDialog";
import CrmButton from "../../ui/CrmButton";
import EmailPreviewFrame from "./EmailPreviewFrame";
import { CRM } from "../../../../constants/testIds/crm";

/**
 * The rendered draft in a modal, with "Send test to me" — the preview a sequence step
 * opens from its header (reachable whether or not the step's form is expanded).
 * `preview` is `useEmailPreview(draft)`'s answer.
 */
export default function EmailPreviewDialog({ open, onOpenChange, preview }) {
  const t = useT("crm");
  return (
    <CrmDialog open={open} onOpenChange={onOpenChange} size="lg" testId={CRM.emailPreviewDialog}
      title={t("emailPreview.title")}
      footer={(
        <CrmButton variant="outline" disabled={preview.sending} onClick={preview.sendTest} data-testid={CRM.emailPreviewSendTest}>
          {t("emailPreview.sendTestToMe")}
        </CrmButton>
      )}>
      {preview.email && <EmailPreviewFrame email={preview.email} />}
      {!preview.email && preview.loading && (
        <p className="text-sm text-eh-muted" aria-busy="true">{t("emailPreview.loading")}</p>
      )}
    </CrmDialog>
  );
}
